/**
 * Which preparation model an unclaimed structure opens with. Pure so the
 * structure screen, the preview and the tests share one answer.
 *
 * Order: the route's own ?model= param, then the insurer link that named this
 * very structure (pendingProperty), then the model an insurer page chose for
 * a visitor who has not picked a home yet (pendingModel). undefined means
 * "today's fallback" (the recommended or default homeowner model).
 *
 * A claimed structure never calls this: the claim's own model always wins.
 */
export function resolveStructureModelId(args: {
  structureId: string;
  modelParam?: string | null;
  pendingProperty?: { structureId: string; checklistId?: string } | null;
  pendingModel?: string | null;
}): string | undefined {
  const { structureId, modelParam, pendingProperty, pendingModel } = args;
  if (modelParam) return modelParam;
  if (pendingProperty?.structureId === structureId && pendingProperty.checklistId) {
    return pendingProperty.checklistId;
  }
  return pendingModel || undefined;
}
